<template>
  <v-chart class="chart" :option="option" />
  <div class="flex items-center justify-center w-full gap-3 text-[#9598A3]">
    <div class="flex items-center justify-center gap-1">
      <div class="w-4 h-4 bg-[#C6D3ED] rounded-full"></div>
      <h1>Lessons to do</h1>
    </div>
    <div class="flex items-center justify-center gap-1">
      <div class="w-4 h-4 bg-[#9F94FD] rounded-full"></div>
      <h1>Lessons Complete</h1>
    </div>
    <div class="flex items-center justify-center gap-1">
      <div class="w-4 h-4 bg-[#7F56D9] rounded-full"></div>
      <h1>Already Mastered</h1>
    </div>
  </div>
</template>

<script setup>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import VChart from "vue-echarts";
import { ref } from "vue";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);

// provide(THEME_KEY, "dark");
const baseline = [
  3, 3, 6, 7, 7, 7, 8, 8, 8, 10, 10, 11, 11, 11, 11, 13, 13, 13, 13, 14, 14, 14,
  15, 15, 15, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 18, 18, 18, 19, 19, 20,
  20, 20,
];
const improvement = [
  8, 14, 6, 7, 20, 16, 14, 9, 8, 10, 17, 11, 12, 19, 11, 13, 18, 13, 14, 14, 15,
  14, 15, 18, 16, 15, 20, 15, 15, 19, 16, 16, 16, 19, 17, 18, 20, 19, 19, 20,
  20, 20, 20,
];
console.log("improvement", improvement);
console.log("base", baseline);

const option = ref({
  xAxis: {
    data: [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    name: "Individual Students",
    nameLocation: "middle",
    nameGap: 20,
    axisLabel: {
      formatter: "{value}",
    },
    axisTick: {
      length: 0,
    },
    axisLine: {
      lineStyle: {
        width: 1,
      },
    },
  },
  yAxis: {
    type: "value",
    name: "Lessons",
    min: 0,
    max: 20,
    splitNumber: 20,
    nameLocation: "middle",
    nameGap: 30,
    axisLabel: {
      formatter: "{value}",
    },
    splitLine: {
      lineStyle: {
        type: "dashed",
        color: "#C6D3ED",
      },
    },
  },
  series: [
    {
      data: [
        3, 3, 6, 7, 7, 7, 8, 8, 8, 10, 10, 11, 11, 11, 11, 13, 13, 13, 13, 14,
        14, 14, 15, 15, 15, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 18, 18, 18,
        19, 19, 20, 20, 20,
      ],
      type: "bar",
      stack: "x",
      itemStyle: {
        color: "#7F56D9",
        // borderRadius: [10, 10, 0, 0]
      },
    },
    // incomplete
    {
      data: getData(improvement, baseline),
      type: "bar",
      stack: "x",
      itemStyle: {
        color: "#9F94FD",
        borderRadius: [10, 10, 0, 0],
      },
    },
    //lessons to do
    {
      data: [
        20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20,
        20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20,
        20, 20, 20, 20, 20, 20, 20,
      ],
      type: "bar",
      stack: "x",
      itemStyle: {
        color: "#E5E5E5",
        borderRadius: [10, 10, 0, 0],
      },
    },
  ],
});

function getData(data, base) {
  let result = [];

  data.forEach((element, index) => {
    // incomplete
    result.push(element - base[index]);
  });

  return result;
}
</script>

<style scoped>
.chart {
  height: 400px;
}
</style>
